import { TradingViewTimeFrames } from "@/components/TradingViewWidgets";
import { atom } from "recoil";

export const selectedTimeFrameState = atom({
  key: "selectedTimeFrame",
  default: undefined, // Provide a default value
});

export const setSelectedSymbolState = atom<string | undefined>({
  key: "selectedSymbolState", // Fixed key name to be more accurate
  default: undefined, // Provide a default value
});
